module.exports = __webpack_public_path__ + "img/04.ecc67655.jpg";